function getLineStyle(cls) {
    switch (cls) {
        case 'unknow-face':
            return 'rgba(255, 59, 48, .5)'
        case 'face':
            return 'rgba(52, 199, 89, .5)'
        case 'motion_area':
            return 'rgba(249, 101, 48, .5)'
        case 'viewport_area':
            return 'rgba(101, 249, 48, .5)'
        default:
            return 'rgba(101, 48, 249, .5)'
    }
}
export function drawPDBoxesToCanvas({ boxCanvas, box }) {
    const ctx = boxCanvas.getContext('2d')
    const SHOW_FACE_DETECTION_RESULT = true

    // if (box.cls == 'face' && box.person_name == undefined) return
    // ctx.clearRect(0, 0, boxCanvas.width, boxCanvas.height);

    ctx.beginPath()
    ctx.lineWidth = '4'
    let lineStyle = getLineStyle(box.cls)

    ctx.strokeStyle = lineStyle

    box.x_min = Number.parseInt(box.x_min * boxCanvas.width)
    box.x_max = Number.parseInt(box.x_max * boxCanvas.width)
    box.y_min = Number.parseInt(box.y_min * boxCanvas.height)
    box.y_max = Number.parseInt(box.y_max * boxCanvas.height)

    ctx.rect(box.x_min, box.y_min, box.x_max - box.x_min, box.y_max - box.y_min)
    ctx.stroke()
    ctx.closePath()
    ctx.fillStyle = lineStyle

    let textPosY = box.y_min + 25
    ctx.fillRect(box.x_min, box.y_min, box.x_max - box.x_min, 30)
    if (SHOW_FACE_DETECTION_RESULT) {
        if (box.person_name) {
            ctx.fillRect(box.x_min, box.y_min + 30, box.x_max - box.x_min, 30)
        }
        // let box_text = `${Number(box.cls_score.toFixed(3))} ${box.cls}`
        let box_text = ` ${box.cls}`
        ctx.fillStyle = 'white'
        ctx.font = '30px Arial'
        ctx.fillText(box_text, box.x_min + 10, textPosY)
        textPosY += 30
    }
    if (box.person_name) {
        ctx.fillStyle = 'white'
        ctx.font = '30px Arial'
        ctx.fillText(box.person_name, box.x_min + 10, textPosY)
    }

    const kp_colors = [
        'rgba(237, 33, 14,0.7)',
        'rgba(237, 126, 14,0.7)',
        'rgba(55, 237, 14,0.7)',
        'rgba(14, 215, 237,0.7)',
        'rgba(21, 14, 237,0.7)',
    ]

    if (box.keypoints !== undefined) {
        box.keypoints = box.keypoints.map((v, i) => {
            if (i % 2 == 0) return Number.parseInt(v * boxCanvas.height)
            else return Number.parseInt(v * boxCanvas.width)
        })

        const kp = box.keypoints
        for (let i = 0; i < kp.length; i += 2) {
            ctx.fillStyle = kp_colors[Number.parseInt(i / 2) % kp_colors.length]
            ctx.fillRect(kp[i + 1] - 3, kp[i] - 3, 6, 6)
        }
    }
}

export function drawFaceRecToCanvas({ boxCanvas, box }) {
    const ctx = boxCanvas.getContext('2d')

    if (box.cls != 'face' || box.person_name == undefined) return

    if (box.x_max < 1.0 && box.y_max < 1.0) {
        box.x_min = Number.parseInt(box.x_min * boxCanvas.width)
        box.x_max = Number.parseInt(box.x_max * boxCanvas.width)
        box.y_min = Number.parseInt(box.y_min * boxCanvas.height)
        box.y_max = Number.parseInt(box.y_max * boxCanvas.height)
    }

    // ctx.beginPath()
    // ctx.lineWidth = ''
    // if (box.cls == 'motion_area') ctx.strokeStyle = `rgba(249,101,48,0.5)`
    let lineStyle = getLineStyle(box.familiar ? 'face' : 'unknow-face')
    // ctx.rect(box.x_min, box.y_min, box.x_max - box.x_min, box.y_max - box.y_min);
    // ctx.stroke()
    // ctx.closePath()

    // if (box.cls == 'motion_area') ctx.fillStyle = `rgba(249,101,48,0.5)`
    // else if (box.cls == 'viewport_area') ctx.fillStyle = `rgba(101,249,48,0.5)`
    ctx.fillStyle = lineStyle

    const LINE_SIZE = 5
    const X_SIZE = (box.x_max - box.x_min) / 4
    const Y_SIZE = (box.y_max - box.y_min) / 4

    ctx.shadowBlur = 0
    ctx.fillRect(
        box.x_min + LINE_SIZE,
        box.y_min,
        X_SIZE - LINE_SIZE,
        LINE_SIZE
    )
    ctx.fillRect(box.x_min, box.y_min, LINE_SIZE, Y_SIZE)
    ctx.fillRect(
        box.x_min + LINE_SIZE,
        box.y_max - LINE_SIZE,
        X_SIZE - LINE_SIZE,
        LINE_SIZE
    )
    ctx.fillRect(box.x_min, box.y_max - Y_SIZE, LINE_SIZE, Y_SIZE)
    ctx.fillRect(box.x_max - X_SIZE, box.y_min, X_SIZE - LINE_SIZE, LINE_SIZE)
    ctx.fillRect(box.x_max - LINE_SIZE, box.y_min, LINE_SIZE, Y_SIZE)
    ctx.fillRect(
        box.x_max - X_SIZE,
        box.y_max - LINE_SIZE,
        X_SIZE - LINE_SIZE,
        LINE_SIZE
    )
    ctx.fillRect(box.x_max - LINE_SIZE, box.y_max - Y_SIZE, LINE_SIZE, Y_SIZE)
    //ctx.fillRect(box.x_min, box.y_min, box.x_max - box.x_min, 30)

    if (box.person_name) {
        let name = box.person_name
        const matches = name.match(/^\[[0-9]+%\]/)
        let score = ''
        if (matches && matches.length > 0) {
            score = matches[0].replace('[', '').replace(']', '')
            name = name.substr(matches[0].length).trim()
        }
        const TEXT_POS_Y = box.y_max - LINE_SIZE - 5
        ctx.fillStyle = '#f8f8f8'
        ctx.shadowColor = '#181818'
        ctx.font = '30px Open Sans'
        ctx.shadowBlur = 3
        ctx.textAlign = 'start'
        if (score.length > 0)
            ctx.fillText(score, box.x_min + LINE_SIZE + 3, box.y_min + 35)
        ctx.textAlign = 'end'
        ctx.fillText(name, box.x_max - LINE_SIZE, TEXT_POS_Y)
    }
}

export function drawFaceEllipse({ boxCanvas, box }) {
    const ctx = boxCanvas.getContext('2d')

    if (box.keypoints !== undefined) {
        box.keypoints = box.keypoints.map((v, i) => {
            if (i % 2 == 0) return Number.parseInt(v * boxCanvas.height)
            else return Number.parseInt(v * boxCanvas.width)
        })
        const kp = [
            [box.keypoints[1], box.keypoints[0]],
            [box.keypoints[3], box.keypoints[2]],
            [box.keypoints[5], box.keypoints[4]],
            [box.keypoints[7], box.keypoints[6]],
            [box.keypoints[9], box.keypoints[8]],
        ]

        let x = 0
        let y = 0
        for (const k of kp) {
            x += k[0]
            y += k[1]
        }
        x /= 5
        y /= 5
        let rad_x =
            Math.pow(kp[0][0] - kp[1][0], 2) + Math.pow(kp[0][1] - kp[1][1], 2)
        rad_x = Math.sqrt(rad_x)
        let rad_y =
            Math.pow(kp[0][0] - kp[4][0], 2) + Math.pow(kp[0][1] - kp[4][1], 2)
        rad_y = Math.sqrt(rad_y)

        let eye_rotate = Math.atan2(kp[0][1] - kp[1][1], kp[0][0] - kp[1][0])

        ctx.lineWidth = '6'
        ctx.strokeStyle = `rgba(101,48,249,0.5)`

        ctx.beginPath()
        ctx.ellipse(x, y, rad_x, rad_y, eye_rotate, 0, 2 * Math.PI)
        ctx.stroke()
        ctx.closePath()

        console.log(
            'drawFaceEllipse: ',
            x,
            y,
            rad_x,
            rad_y,
            eye_rotate,
            0,
            2 * Math.PI
        )
    }
}

export function drawFacesToCanvas(
    boxCanvas,
    face_crops,
    offset = {
        x: 10,
        y: 10,
    }
) {
    const ctx = boxCanvas.getContext('2d')
    const N = face_crops.length
    const thumbnail = {
        w: 80,
        h: 80,
    }

    for (let i = 0; i < N; i++) {
        const bitmap = face_crops[i]
        if (bitmap === undefined) continue
        ctx.drawImage(
            bitmap,
            offset.x * (i + 1) + thumbnail.w * i,
            offset.y,
            thumbnail.w,
            thumbnail.h
        )

        ctx.strokeStyle = `rgba(14, 215, 237,0.5)`
        ctx.beginPath()
        ctx.lineWidth = '3'
        ctx.rect(
            offset.x * (i + 1) + thumbnail.w * i,
            offset.y,
            thumbnail.w,
            thumbnail.h
        )
        ctx.stroke()

        ctx.beginPath()
        ctx.moveTo(
            offset.x * (i + 1) + thumbnail.w * i,
            offset.y + thumbnail.h / 2
        )
        ctx.lineTo(
            offset.x * (i + 1) + thumbnail.w * (i + 1),
            offset.y + thumbnail.h / 2
        )
        ctx.stroke()

        ctx.beginPath()
        ctx.moveTo(
            offset.x * (i + 1) + thumbnail.w * i + thumbnail.w / 2,
            offset.y
        )
        ctx.lineTo(
            offset.x * (i + 1) + thumbnail.w * i + thumbnail.w / 2,
            offset.y + thumbnail.h
        )
        ctx.stroke()
    }
}
